export const heading = [
  "Name",
  "Age",
  "Position",
  "Address",
  "Qualifications",
  "Salary",
];

export const data = [
  {
    id: 1,
    name: "Rajesh",
    position: "System Architect",
    address: "Patna",
    age: "61",
    qualifications: "MCA",
    salary: "50000",
  },
  {
    id: 2,
    name: "Vandana",
    position: "Accountant",
    address: "Patna",
    age: "41",
    qualifications: "MCA",
    salary: "50000",
  },
  {
    id: 3,
    name: "Ravi",
    position: "Accountant",
    address: "Raipur",
    age: "25",
    qualifications: "B.Tech",
    salary: "40000",
  },
  {
    id: 4,
    name: "Poonam",
    position: "Software Engineer",
    address: "Bilaspur",
    age: "38",
    qualifications: "MCA",
    salary: "25000",
  },
  {
    id: 5,
    name: "Rahul",
    position: "Software Developer ",
    address: "Bilaspur",
    age: "38",
    qualifications: "MCA",
    salary: "50000",
  },
  {
    id: 6,
    name: "Aditya",
    position: "Software Engineer",
    address: "Bhilai",
    age: "38",
    qualifications: "MCA",
    salary: "50000",
  },
  {
    id: 7,
    name: "Vikas",
    position: "System Architect",
    address: "Delhi",
    age: "38",
    qualifications: "MCA",
    salary: "50000",
  },
  {
    id: 8,
    name: "Shivani",
    position: "Accountant",
    address: "Delhi",
    age: "25",
    qualifications: "B.Com",
    salary: "50000",
  },
  {
    id: 9,
    name: "Pooja",
    position: "Accountant",
    address: "Bhilai",
    age: "38",
    qualifications: "BCOM",
    salary: "22000",
  },
  {
    id: 10,
    name: "Swapnil",
    position: "Software Engineer",
    address: "Raigarh",
    age: "27",
    qualifications: "MCA",
    salary: "18000",
  },
];
